export default __webpack_public_path__ + "static/media/img-quotes-bubble@2x.80d9154b.png";